"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { Car, Sparkles, User, PartyPopper } from "lucide-react";
export default function ServiceDetails() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    id: 1,
    title: "Luxury Black Car Chauffeur Service",
    description: "Experience the epitome of elegance with our premium sedan service, perfect for business executives and discerning travelers seeking sophistication and comfort.",
    icon: Car,
    bgImage: "/img/luxury_sedan_chauffeur_service.png",
    delay: "0ms"
  }, {
    id: 2,
    title: "SUV Chauffeur Service",
    description: "Spacious and refined, our luxury SUVs provide ample room and VIP comfort for group travel, family journeys, or those who prefer extra space without compromising style.",
    icon: Sparkles,
    bgImage: "/img/premium_suv_interior_vip.png",
    delay: "100ms"
  }, {
    id: 3,
    title: "Airport Transfers",
    description: "Punctual, reliable, and stress-free airport pickups and drop-offs. Our professional chauffeurs monitor flight schedules to ensure seamless arrivals and departures.",
    icon: User,
    bgImage: "/img/chauffeur_airport_transfer_service.png",
    delay: "200ms"
  }, {
    id: 4,
    title: "Hourly & Event Bookings",
    description: "From corporate functions to gala events, our flexible hourly service provides discreet, premium transportation tailored to your schedule and special occasions.",
    icon: PartyPopper,
    bgImage: "/img/luxury_car_event_transportation.png",
    delay: "300ms"
  }];
  const refs = [ref1, ref2, ref3, ref4];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4];
  return <section id="service-details" className="dark bg-background text-foreground section-padding px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold mb-4 tracking-tight">
            Our Premium Services
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto">
            Discover our comprehensive range of luxury chauffeur services, each designed to deliver
            exceptional comfort, punctuality, and discretion throughout Los Angeles and surrounding
            areas.
          </p>
        </div>

        <div className="grid gap-8 md:gap-10 lg:gap-12">
          {services.map((service, i) => {
          const Icon = service.icon;
          const ref = refs[i];
          const isVisible = visibilities[i];
          return <div key={service.id} data-index={i} ref={ref} style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)",
            transition: `opacity var(--duration-slow) var(--ease-smooth) ${service.delay}, transform var(--duration-slow) var(--ease-smooth) ${service.delay}`
          }}>
                <Card className="relative overflow-hidden bg-white/5 backdrop-blur-md border border-white/10 shadow-strong hover:shadow-strong hover:border-secondary/30 group transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] min-h-[400px] md:min-h-[450px] lg:min-h-[500px]">
                  {}
                  <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" style={{
                backgroundImage: `url(${service.bgImage})`
              }} />
                  <div className="absolute inset-0 bg-primary-dark/70 backdrop-blur-[2px] group-hover:bg-primary-dark/60 transition-colors duration-[var(--duration-medium)]" />

                  {}
                  <CardContent className="relative z-10 flex flex-col justify-end h-full p-8 md:p-10 lg:p-12">
                    <div className="mb-6">
                      <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-secondary/20 backdrop-blur-sm border border-secondary/30 mb-6 group-hover:bg-secondary/30 transition-colors duration-[var(--duration-medium)]">
                        <Icon className="w-8 h-8 md:w-10 md:h-10 text-secondary-dark stroke-[1.5]" />
                      </div>
                      <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/cadillac_escalade_luxury.png" alt="2025 Cadillac Escalade SUV" className="mb-6 max-w-[200px] md:max-w-[280px] h-auto object-contain" />

                      <h3 className="text-2xl md:text-3xl lg:text-4xl font-display font-semibold mb-4 text-white tracking-tight">
                        {service.title}
                      </h3>

                      <p className="text-base md:text-lg text-white/90 leading-relaxed mb-6">
                        {service.description}
                      </p>
                    </div>

                    <Link to="#" className="inline-flex items-center gap-2 text-secondary-dark font-semibold text-sm uppercase tracking-wider hover:text-secondary-dark transition-colors duration-[var(--duration-fast)] group/link">
                      Learn More
                      <svg className="w-4 h-4 transition-transform duration-[var(--duration-fast)] group-hover/link:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </CardContent>

                  {}
                  <div className="absolute inset-0 border-2 border-transparent group-hover:border-secondary/20 rounded-xl pointer-events-none transition-colors duration-[var(--duration-medium)]" />
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}